




























































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { FlowConfigVO } from "@/model/FlowConfigVO";
import { RuleFilterVO } from "@/model/FlowDetailVO";
import FlowCondition from "@/components/flow/flow-condition.vue";
import { getPickerOptions } from "@/services/common";
import FlowRelation from "@/components/flow/flow-relation.vue";
import { flowConfigLabel } from "@/i18n/flowConfigLabel";

@Component({
  components: {
    "yc-flow-condition": FlowCondition,
    "yc-flow-relation": FlowRelation,
  },
})
export default class FlowBox extends Vue {
  flowConfigLabel = flowConfigLabel;

  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public config!: FlowConfigVO;

  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public rule!: RuleFilterVO;

  /**
   * 流程状态，后端权限控制
   */
  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  public status!: string;
  /**
   * 是否处于编辑状态，前端权限控制
   */
  @Prop({
    type: Boolean,
    default() {
      return true;
    },
  })
  public editable!: boolean;

  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  public strictType!: string;

  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  public text!: string;

  public height = "inherit";
  public letterList = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];
  public pickerOptions = getPickerOptions();

  /**
   * 事件修改
   */
  eventNameChange(event: RuleFilterVO) {
    event.filters = [];
  }

  /**
   * 新增事件
   */
  AddEvent(rules: RuleFilterVO[], strictType: string) {
    let newRule: RuleFilterVO = {};
    if (strictType === "EVENT_STRICT") {
      newRule = {
        type: "EVENT",
        eventName: "",
        relation: "AND",
        filters: [],
      };
    } else if (strictType === "PROPERTY_STRICT") {
      newRule = {
        type: "FILTER",
        field: "",
        operator: undefined,
        value: [],
      };
    } else if (strictType === "ACTION_STRICT") {
      newRule = {
        timeParams: [],
        timeFunction: "",
        type: "EVENT",
        eventName: "",
        relation: "AND",
        filters: [],
        measure: {
          field: "",
          operator: undefined,
          value: [],
        },
      };
    }
    rules.push(newRule);
    this.height = "inherit";
  }

  /**
   * 删除事件
   */
  deleteEvent(rules: RuleFilterVO[], eventIndex: number) {
    rules.splice(eventIndex, 1);
  }

  /**
   * 新增条件
   */
  AddCondition(filters: RuleFilterVO[]) {
    filters.push({
      type: "FILTER",
      field: "",
      operator: undefined,
      value: [],
    });
  }

  /**
   * 删除条件
   */
  deleteCondition(filters: RuleFilterVO[], filterIndex: number) {
    filters.splice(filterIndex, 1);
  }

  /**
   * 相对时间限制
   */
  campareRelative(event: any, index: number) {
    this.$nextTick().then(() => {
      const params0 = Number(event.timeParams[0]);
      const params1 = Number(event.timeParams[1]);
      if (!Number.isNaN(params0) && !Number.isNaN(params1)) {
        if (index === 0 && params0 <= params1) {
          this.$set(event, 'timeParams', [params1 + 1, params1]);
        }
        if (index === 1 && params0 <= params1) {
          if(params0 === 0) {
            this.$set(event, 'timeParams', [1, 0]);
          } else {
            this.$set(event, 'timeParams', [params0, params0 - 1]);
          }
        }
      }
    })

  }
}
